import React from "react";
import { string } from "prop-types";

const TwitterIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="22"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 2.612a11.433 11.433 0 0 1-2.673 2.87c.011.161.017.402.017.723 0 1.49-.21 2.979-.627 4.468a16.311 16.311 0 0 1-1.914 4.263 16.595 16.595 0 0 1-3.035 3.627c-1.177 1.042-2.596 1.879-4.257 2.509-1.66.619-3.437.928-5.328.928-2.98 0-5.708-.83-8.183-2.492.385.046.814.069 1.287.069 2.474 0 4.68-.791 6.615-2.372a5.09 5.09 0 0 1-3.101-1.1 5.477 5.477 0 0 1-1.881-2.75c.363.057.698.086 1.006.086.473 0 .94-.063 1.403-.19-1.232-.263-2.255-.899-3.069-1.907-.803-1.02-1.204-2.2-1.204-3.54v-.07c.748.436 1.55.67 2.408.705a5.469 5.469 0 0 1-1.732-1.976 5.589 5.589 0 0 1-.643-2.647c0-1.009.242-1.943.726-2.802a15.374 15.374 0 0 0 4.85 4.108 14.516 14.516 0 0 0 6.137 1.701 6.413 6.413 0 0 1-.132-1.271c0-1.536.517-2.842 1.55-3.92C15.267.545 16.526 0 18 0c1.54 0 2.837.584 3.893 1.753a10.197 10.197 0 0 0 3.382-1.34c-.407 1.317-1.188 2.337-2.343 3.059A10.283 10.283 0 0 0 26 2.612Z"
      fill="#1876DB"
    />
  </svg>
);

TwitterIcon.propTypes = {
  className: string
};

TwitterIcon.defaultProps = {
  className: ""
};

export default TwitterIcon;
